<template>
  <div class="tw-w-full">
    <div class="tw-flex tw-items-center tw-justify-between tw-px-1 tw-py-2">
      <div class="tw-text-sm tw-font-semibold tw-text-slate-900">Container appointments</div>
      <div></div>
    </div>

    <div class="tw-overflow-x-auto">
      <table class="tw-min-w-full tw-text-left tw-text-sm tw-text-slate-700">
        <thead class="tw-bg-slate-50/70 tw-text-xs tw-font-semibold tw-uppercase tw-tracking-wide tw-text-slate-600">
          <tr>
            <th class="tw-px-4 tw-py-3">Terminal appointment</th>
            <th class="tw-px-4 tw-py-3">Delivery appointment</th>
          </tr>
        </thead>
        <tbody class="tw-divide-y tw-divide-slate-200/70">
          <tr class="odd:tw-bg-white/30">
            <td class="tw-px-4 tw-py-3">
              <div v-if="editingField === 'terminal'" class="tw-inline-flex tw-items-center tw-gap-2 tw-rounded-xl tw-border tw-border-slate-200/70 tw-bg-white/60 tw-px-2 tw-py-1">
                <div class="tw-min-w-[240px]">
                  <BaseDateTimePicker
                    value-type="YYYY-MM-DD HH:mm" 
                    date-format="MM/DD/YYYY" date-time-format="MM/DD/YYYY HH:mm"
                    :allow-time-toggling="true"
                    :show-days-shortcuts="true"
                    controls-placement="popup"
                    :minute-step="15"
                    textLabel=""
                    time-panel-placement="beside-calendar"
                    v-model="editingContainer.terminalAppointmentDate"
                    v-model:has-time="editingContainer.terminalAppointmentHasTime"
                  ></BaseDateTimePicker>
                </div>
                <button
                  type="button"
                  class="tw-inline-flex tw-h-9 tw-w-9 tw-items-center tw-justify-center tw-rounded-lg tw-border tw-border-slate-200 tw-bg-white/60 tw-text-slate-700 hover:tw-bg-white"
                  title="Cancel"
                  aria-label="Cancel"
                  @click="cancelInlineEdit"
                >
                  <font-awesome-icon icon="xmark" class="tw-h-4 tw-w-4" />
                </button>
                <button
                  type="button"
                  class="tw-inline-flex tw-h-9 tw-w-9 tw-items-center tw-justify-center tw-rounded-lg tw-border tw-border-transparent tw-bg-slate-900 tw-text-white hover:tw-bg-slate-800"
                  title="Save"
                  aria-label="Save"
                  @click="saveInlineEdit('terminal')"
                >
                  <font-awesome-icon icon="check" class="tw-h-4 tw-w-4" />
                </button>
              </div>
              <div v-else class="tw-flex tw-items-center tw-justify-between tw-gap-2">
                <div class="tw-min-w-0">
                  <span v-if="container.terminalAppointmentDate">
                    {{ formatAppointmentDatetime(container.terminalAppointmentDate, container.terminalAppointmentHasTime, true) }}
                  </span>
                  <span v-else class="tw-text-slate-400">—</span>
                </div>
                <button
                  type="button"
                  class="tw-inline-flex tw-h-8 tw-w-8 tw-flex-shrink-0 tw-items-center tw-justify-center tw-rounded-lg tw-border tw-border-slate-200 tw-bg-white/60 tw-text-slate-700 hover:tw-bg-white"
                  title="Edit terminal appointment"
                  aria-label="Edit terminal appointment"
                  @click="startInlineEdit('terminal')"
                >
                  <font-awesome-icon icon="pen-to-square" class="tw-h-4 tw-w-4" />
                </button>
              </div>
            </td>
            <td class="tw-px-4 tw-py-3">
              <div v-if="editingField === 'delivery'" class="tw-inline-flex tw-items-center tw-gap-2 tw-rounded-xl tw-border tw-border-slate-200/70 tw-bg-white/60 tw-px-2 tw-py-1">
                <div class="tw-min-w-[240px]">
                  <BaseDateTimePicker
                    value-type="YYYY-MM-DD HH:mm" 
                    date-format="MM/DD/YYYY" date-time-format="MM/DD/YYYY HH:mm"
                    :allow-time-toggling="true"
                    :show-days-shortcuts="true"
                    controls-placement="popup"
                    :minute-step="15"
                    textLabel=""
                    time-panel-placement="beside-calendar"
                    v-model="editingContainer.deliveryAppointmentDate"
                    v-model:has-time="editingContainer.deliveryAppointmentHasTime"
                  ></BaseDateTimePicker>
                </div>
                <button
                  type="button"
                  class="tw-inline-flex tw-h-9 tw-w-9 tw-items-center tw-justify-center tw-rounded-lg tw-border tw-border-slate-200 tw-bg-white/60 tw-text-slate-700 hover:tw-bg-white"
                  title="Cancel"
                  aria-label="Cancel"
                  @click="cancelInlineEdit"
                >
                  <font-awesome-icon icon="xmark" class="tw-h-4 tw-w-4" />
                </button>
                <button
                  type="button"
                  class="tw-inline-flex tw-h-9 tw-w-9 tw-items-center tw-justify-center tw-rounded-lg tw-border tw-border-transparent tw-bg-slate-900 tw-text-white hover:tw-bg-slate-800"
                  title="Save"
                  aria-label="Save"
                  @click="saveInlineEdit('delivery')"
                >
                  <font-awesome-icon icon="check" class="tw-h-4 tw-w-4" />
                </button>
              </div>
              <div v-else class="tw-flex tw-items-center tw-justify-between tw-gap-2">
                <div class="tw-min-w-0">
                  <span v-if="container.deliveryAppointmentDate">
                    {{ formatAppointmentDatetime(container.deliveryAppointmentDate, container.deliveryAppointmentHasTime, true) }}
                  </span>
                  <span v-else class="tw-text-slate-400">—</span>
                </div>
                <button
                  type="button"
                  class="tw-inline-flex tw-h-8 tw-w-8 tw-flex-shrink-0 tw-items-center tw-justify-center tw-rounded-lg tw-border tw-border-slate-200 tw-bg-white/60 tw-text-slate-700 hover:tw-bg-white"
                  title="Edit delivery appointment"
                  aria-label="Edit delivery appointment"
                  @click="startInlineEdit('delivery')"
                >
                  <font-awesome-icon icon="pen-to-square" class="tw-h-4 tw-w-4" />
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';
import BaseDateTimePicker from '@/components/core/DateTime/BaseDateTimePicker.vue';
import UpdateContainerDetailsMutation from '@/gql/containers/mutations/UpdateContainerDetails.gql';

import { datetimeFormatMixin } from '../../utils/date';

type DispatchContainerInfoContainer = {
  id: number;
  terminalAppointmentDate?: string | null;
  terminalAppointmentHasTime?: boolean | null;
  deliveryAppointmentDate?: string | null;
  deliveryAppointmentHasTime?: boolean | null;
};

export default defineComponent({
  data() {
    return {
      editingContainer: {
        terminalAppointmentDate: null,
        terminalAppointmentHasTime: true,
        deliveryAppointmentDate: null,
        deliveryAppointmentHasTime: true,
      },
      editingField: null as 'terminal' | 'delivery' | null,
    };
  },
  mixins: [datetimeFormatMixin],
  methods: {
    startInlineEdit(field: 'terminal' | 'delivery') {
      const vm = (this as any);
      vm.editingField = field;

      // Initialize draft values from current container state
      vm.editingContainer.terminalAppointmentDate = vm.container?.terminalAppointmentDate || null;
      vm.editingContainer.terminalAppointmentHasTime = vm.container?.terminalAppointmentHasTime ?? true;
      vm.editingContainer.deliveryAppointmentDate = vm.container?.deliveryAppointmentDate || null;
      vm.editingContainer.deliveryAppointmentHasTime = vm.container?.deliveryAppointmentHasTime ?? true;
    },
    cancelInlineEdit() {
      const vm = (this as any);
      vm.editingField = null;
      vm.editingContainer.terminalAppointmentDate = null;
      vm.editingContainer.terminalAppointmentHasTime = true;
      vm.editingContainer.deliveryAppointmentDate = null;
      vm.editingContainer.deliveryAppointmentHasTime = true;
    },
    saveInlineEdit(field: 'terminal' | 'delivery') {
      const vm = (this as any);
      const variables: any = { containerId: vm.container.id };

      if (field === 'terminal') {
        variables.terminalAppointmentDate = vm.editingContainer.terminalAppointmentDate;
        variables.terminalAppointmentHasTime = vm.editingContainer.terminalAppointmentHasTime;
      } else {
        variables.deliveryAppointmentDate = vm.editingContainer.deliveryAppointmentDate;
        variables.deliveryAppointmentHasTime = vm.editingContainer.deliveryAppointmentHasTime;
      }

      vm.$apollo
        .mutate({
          mutation: UpdateContainerDetailsMutation,
          variables,
        })
        .then(() => {
          vm.editingField = null;
          vm.editingContainer.terminalAppointmentDate = null;
          vm.editingContainer.terminalAppointmentHasTime = true;
          vm.editingContainer.deliveryAppointmentDate = null;
          vm.editingContainer.deliveryAppointmentHasTime = true;
          if (vm.$apollo?.queries?.container) {
            vm.$apollo.queries.container.refetch();
          }
        })
        .catch((err: any) => {
          console.error(err);
        });
    },
  },
  components: {
    BaseDateTimePicker,
  },
  props: {
    container: {
      type: Object as PropType<DispatchContainerInfoContainer>,
      required: true,
    },
  },
});
</script>
